import { state } from '@/manager/employee/store/state';
import { getters } from '@/manager/employee/store/getters';
import { mutations } from '@/manager/employee/store/mutations';
import { actions } from '@/manager/employee/store/action';

export const employee = {
    state,
    getters,
    actions,
    mutations,
};
